import { AgentCapabilities, buildAgentCapabilities } from '../agents/models/AgentCapabilities';
import { ChatProviderType } from '../chat/models/ChatProviderType';
import { ChatSession } from '../chat/models/ChatSession';
import { Agent } from '../agents/models/Agent';
import { isNexusAgent } from '../../features/utils/AgentUtils';

// Determine the capabilities of a chat session based on provider type and any resolved agent metadata.
// Capabilities default to false, so features must be explicitly enabled here.
export const resolveChatSessionCapabilities = (
    session: ChatSession,
    resolvedAgent: Agent | null,
): AgentCapabilities => {
    if (session.providerType === ChatProviderType.Assistants) {
        return buildAgentCapabilities({ hasOverview: true, supportsDownloadChatSession: true });
    }

    if (session.providerType === ChatProviderType.ProGPT) {
        return buildAgentCapabilities({
            supportsDocumentUpload: true,
            supportsImageUpload: true,
            supportsBulkPromptUpload: true,
            supportsPersonaCustomization: true,
            supportsToolkit: true,
            supportsPromptEnhancer: true,
            supportsKnowledgeSources: true,
            supportsThinkLonger: true,
            hasOverview: true,
            supportsDownloadChatSession: true,
            supportsChatRenaming: true,
        });
    }


    const isCodeInterpreterEnabled = isNexusAgent(resolvedAgent) && resolvedAgent.allowCodeInterpreterAtConversationLevel === true;
    const isFileSearchEnabled = isNexusAgent(resolvedAgent) && resolvedAgent.allowFileSearchAtConversationLevel === true;

    return buildAgentCapabilities({
        supportsDocumentUpload: isCodeInterpreterEnabled || isFileSearchEnabled,
        supportsImageUpload: isCodeInterpreterEnabled,
        supportsBulkPromptUpload: false,
        supportsToolkit: true,
        supportsPromptEnhancer: true,
        hasOverview: true,
        supportsChatRenaming: true,
    });
};
